import { Button, DataSource, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAvailableLoads extends Layout {
    buttonBlastAllOffers: Button;
    buttonRefresh: Button;
    panelCenterTools: Panel;
    sourceAvailableLoads: DataSource;
    tableAvailableLoads: Table;
    textboxCutoffDate: Textbox;
    textboxLoadToRadius: Textbox;
    textboxLocationRadius: Textbox;
    textboxMaxLoads: Textbox;
}
